import React from 'react';
import 'antd/dist/antd.css';
import { Button, Icon, List } from 'antd';
import { connect } from 'react-redux';
import './ComponentSelectionForm.css';

const ComponentSelectionForm = props => {
    const handleComponentSelected = event => {
        const { onComponentSelected } = props;
        onComponentSelected && onComponentSelected(event.target.value);
    };

    return (
        <List
            className="componentSelectionList"
            dataSource={props.compList}
            renderItem={item => (
                <List.Item key={item.name}>
                    <List.Item.Meta avatar={<Icon type="container" theme="filled" />} title={item.name} description={item.description} />
                    <Button type="primary" icon="plus" size="small" value={item.name} onClick={handleComponentSelected} />
                </List.Item>
            )}
        />
    );
};

const mapStateToProps = state => ({
    i18n: state.i18n
});

export default connect(
    mapStateToProps,
    null
)(ComponentSelectionForm);
